<template>
    <div id="login">
        <div class="white-frame">
            <div class="text-center"><img src="/static/img/logo.png" class="mb-3"></div>
            <h4 class="text-center mb-3">Forgot your Password?</h4>
            <p class="text-center">Enter your email below to receive your password reset instructions</p>
            <b-form @submit="onSubmit" @reset="onReset">
                <b-form-group id="emailgrp"
                              label="Email"
                              label-for="email">
                    <b-form-input id="email"
                                  type="text"
                                  required
                                  placeholder="Enter email address">
                    </b-form-input>
                </b-form-group>
                <b-button class=" btn-orange mt-4 mb-3" size="lg" :block="true">
                    <i class="dripicons-clockwise mr-2"></i>Reset Password
                </b-button>
                <div class="text-center">
                    <router-link to="/login" class=" btn">
                        <i class="dripicons-cross mr-2"></i>Cancel
                    </router-link>
                </div>
            </b-form>
        </div>

        <div class="white-frame" v-show="showSuccessContent">
            <div class="text-center"><img src="/static/img/logo.png" class="mb-3"></div>
            <h4 class="text-center mb-3">Check your email!</h4>
            <p class="text-center">We just sent you an email with instructions for resetting your password</p>

            <b-button class=" btn-orange mt-4 mb-3" size="lg" :block="true">
                <i class="dripicons-mail mr-2"></i>Resend Instructions
            </b-button>
            <div class="text-center">
                <router-link to="/login" class=" btn">
                    <i class="dripicons-arrow-thin-right mr-2"></i>Login Now
                </router-link>
            </div>

        </div>
    </div>
</template>

<script>
  export default {
    name: "ForgotPassword",
    components: {},
    data() {
      return {
        showSuccessContent: false
      }
    }
  }
</script>

<style scoped>
    #login {
        background-image: url('/static/img/login_bg.jpg');
        background-size: cover;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .form-control {
        -webkit-box-shadow: 0 3px 13px -6px #777777c7;
        -moz-box-shadow: 0 3px 13px -6px #777777c7;
        box-shadow: 0 3px 13px -6px #777777c7;
    }
</style>



// WEBPACK FOOTER //
// src/views/ForgotPassword.vue